module.exports = __webpack_public_path__ + "media/images/team-1-537396a7.png";